@if (externalLink) {
  <a [href]="externalLink" target="_blank" class="link-list-item size-{{ size }}">
    <ng-container *ngTemplateOutlet="listitemcontent"></ng-container>
  </a>
}
@if (link) {
  <a [routerLink]="link" [queryParams]="query" [fragment]="fragment" class="link-list-item size-{{ size }}">
    <ng-container *ngTemplateOutlet="listitemcontent"></ng-container>
  </a>
}
@if (!link && !externalLink) {
  <div class="link-list-item size-{{ size }}">
    <ng-container *ngTemplateOutlet="listitemcontent"></ng-container>
  </div>
}
<ng-template #listitemcontent>
  @if (image || customIcon) {
    <div class="item-image style-{{ imageStyle }}">
      @if (image && image !== 'EMPTY') {
        <img [src]="image | storyblokCdn" alt="" loading="lazy" />
      }
      @if (customIcon) {
        <div [innerHTML]="sanitization.bypassSecurityTrustHtml(customIcon)"></div>
      }
    </div>
  }
  <div class="list-item-content">
    @if (title) {
      <h3>{{ title }}</h3>
    }
    @if (description) {
      <p>{{ description }}</p>
    }
  </div>
  @if (link || externalLink) {
    <div class="link-icon" [class.external]="!!externalLink">
      <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
    </div>
  }
  <ng-content></ng-content>
</ng-template>
